import { render, staticRenderFns } from "./ExceptionButton.vue?vue&type=template&id=8a7ca036&scoped=true&"
import script from "./ExceptionButton.vue?vue&type=script&lang=js&"
export * from "./ExceptionButton.vue?vue&type=script&lang=js&"
import style0 from "./ExceptionButton.vue?vue&type=style&index=0&id=8a7ca036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7ca036",
  null
  
)

export default component.exports